var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-page-header",
        { staticClass: "page-header", on: { back: _vm.back } },
        [
          _c(
            "div",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { slot: "title" },
              on: { click: _vm.back },
              slot: "title",
            },
            [
              _vm._v("\n      返回 班级管理/\n      "),
              _c("span", { staticStyle: { color: "#297ede" } }, [
                _vm._v(_vm._s(_vm.cardObj.title)),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }